<script setup lang="ts">
import { ref, watch } from 'vue';
import { useLoadingState } from '@/loading';
import { useProject } from '@/services/projects';
import type { RouteLocationRaw } from 'vue-router';
import TeemillPlatformLogo from './TeemillPlatformLogo.vue';

defineProps<{
  hideText: boolean;
}>();

const project = useProject();
const { loaded } = useLoadingState();

const link = ref<RouteLocationRaw>();

watch(
  () => loaded,
  (hasLoaded) => {
    link.value = undefined;

    if (!hasLoaded) {
      return;
    }

    // nextTick(() => {
    if (project === undefined) {
      link.value = { name: 'dashboard' };
      return;
    }

    // if (router.hasRoute('project.dashboard')) {
    //   link.value = {
    //     name: 'project.dashboard',
    //     params: {
    //       project: route.params.project,
    //     },
    //   };

    //   return;
    // }

    link.value = { name: 'dashboard' };
    //   return;
    // });
  },
  {
    immediate: true,
  },
);
</script>

<template>
  <RouterLink v-if="link" :to="link" class="flex h-full w-full items-center" aria-label="Home">
    <TeemillPlatformLogo class="h-full py-3" />
  </RouterLink>
</template>
